// @ts-nocheck
(function () {
  if (window.__contactApiFormInitialized) return;
  window.__contactApiFormInitialized = true;

  var allCountriesCache = null;
  var countryRegionsCache = {};
  var REGION_OPTIONS = {
    'united states': {
      label: 'State',
      values: [
        'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Florida',
        'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine',
        'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska',
        'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota',
        'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota',
        'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'
      ]
    },
    canada: {
      label: 'Province',
      values: [
        'Alberta', 'British Columbia', 'Manitoba', 'New Brunswick', 'Newfoundland and Labrador',
        'Nova Scotia', 'Ontario', 'Prince Edward Island', 'Quebec', 'Saskatchewan'
      ]
    }
  };

  function getFallbackRegionsForCountry(countryName) {
    var key = normalizeCountryName(countryName);
    return REGION_OPTIONS[key] || null;
  }

  function fetchCountryRegions(countryName) {
    var normalized = normalizeCountryName(countryName);
    if (!normalized) {
      return Promise.resolve(null);
    }

    if (countryRegionsCache[normalized]) {
      return Promise.resolve(countryRegionsCache[normalized]);
    }

    var fallback = getFallbackRegionsForCountry(countryName);

    return fetch('https://countriesnow.space/api/v0.1/countries/states', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        country: countryName
      })
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Region API request failed');
        }
        return response.json();
      })
      .then(function (payload) {
        var states = payload && payload.data && Array.isArray(payload.data.states) ? payload.data.states : [];

        var values = states
          .map(function (entry) {
            return entry && entry.name ? entry.name.trim() : '';
          })
          .filter(Boolean);

        var uniqueValues = Array.from(new Set(values));

        if (!uniqueValues.length) {
          countryRegionsCache[normalized] = fallback;
          return fallback;
        }

        var result = {
          label: fallback && fallback.label ? fallback.label : 'State / Province',
          values: uniqueValues
        };

        countryRegionsCache[normalized] = result;
        return result;
      })
      .catch(function () {
        countryRegionsCache[normalized] = fallback;
        return fallback;
      });
  }

  function normalizeCountryName(name) {
    return (name || '')
      .toString()
      .trim()
      .toLowerCase()
      .replace(/[.,]/g, '');
  }

  function isSameCountryName(a, b) {
    var left = normalizeCountryName(a);
    var right = normalizeCountryName(b);

    if (!left || !right) return false;
    if (left === right) return true;

    var usAliases = ['united states', 'united states of america', 'usa', 'us'];
    if (usAliases.indexOf(left) !== -1 && usAliases.indexOf(right) !== -1) return true;

    return false;
  }

  function normalizeCallingCode(value) {
    var code = (value || '').toString().replace(/\s+/g, '');
    if (!code) return '';
    return code.charAt(0) === '+' ? code : '+' + code.replace(/^\++/, '');
  }

  function normalizeCountryDisplayName(name) {
    return (name || '')
      .toString()
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getCountryFlagUrl(isoCode) {
    if (!isoCode || isoCode.length !== 2) return '';
    return 'https://flagcdn.com/24x18/' + isoCode.toLowerCase() + '.png';
  }

  function updatePhonePrefix(form) {
    var prefixEl = form.querySelector('[data-phone-prefix]');
    var countryCodeSelect = form.querySelector('[name="countryCode"]');
    if (!prefixEl || !countryCodeSelect) return;

    var selectedOption = countryCodeSelect.options[countryCodeSelect.selectedIndex];
    var selectedCode = selectedOption && selectedOption.dataset.callingCode ? selectedOption.dataset.callingCode : countryCodeSelect.value;
    var code = normalizeCallingCode(selectedCode);
    prefixEl.textContent = code || '+';
    syncCountryCodePicker(countryCodeSelect);
  }

  function parseCountriesNowList(list) {
    var parsed = [];

    (list || []).forEach(function (country) {
      var countryName = normalizeCountryDisplayName(country && country.name ? country.name : '');
      var codeValue = country && country.code ? country.code.toString() : '';
      var hasNumericCode = /\d/.test(codeValue);
      var rawDialCode = country && country.dial_code ? country.dial_code : hasNumericCode ? codeValue : '';
      var dialCode = normalizeCallingCode(rawDialCode);
      var isoCode = (country && country.iso2 ? country.iso2 : country && country.code ? country.code : '').toUpperCase();
      var flagUrl = getCountryFlagUrl(isoCode || '');

      if (!countryName || !dialCode) return;

      parsed.push({
        name: countryName,
        code: dialCode,
        iso2: isoCode,
        flagUrl: flagUrl
      });
    });

    parsed.sort(function (a, b) {
      return a.name.localeCompare(b.name);
    });

    return parsed;
  }

  function fetchAllCountries() {
    if (allCountriesCache) {
      return Promise.resolve(allCountriesCache);
    }

    return fetch('country-calling-codes.json')
      .then(function (response) {
        if (!response.ok) throw new Error('Failed to fetch local country list');
        return response.json();
      })
      .then(function (countries) {
        var parsed = parseCountriesNowList(countries);
        if (!parsed.length) {
          throw new Error('Empty local country list');
        }
        allCountriesCache = parsed;
        return parsed;
      })
      .catch(function () {
        return fetch('https://countriesnow.space/api/v0.1/countries/codes')
          .then(function (response) {
            if (!response.ok) throw new Error('Failed to fetch countries from API');
            return response.json();
          })
          .then(function (payload) {
            var list = payload && payload.data && Array.isArray(payload.data) ? payload.data : [];
            var parsed = parseCountriesNowList(list);
            if (!parsed.length) {
              throw new Error('Empty countries API payload');
            }
            allCountriesCache = parsed;
            return parsed;
          });
      })
      .catch(function () {
        return [
          { name: 'United States', code: '+1', iso2: 'US', flagUrl: getCountryFlagUrl('US') },
          { name: 'Canada', code: '+1', iso2: 'CA', flagUrl: getCountryFlagUrl('CA') }
        ];
      });
  }

  function getSelectedCountryCodeOption(selectEl) {
    return selectEl.options[selectEl.selectedIndex] || selectEl.options[0] || null;
  }

  function closeCountryCodePicker(selectEl) {
    if (!selectEl || !selectEl.__countryCodePicker) return;

    selectEl.__countryCodePicker.button.setAttribute('aria-expanded', 'false');
    selectEl.__countryCodePicker.list.hidden = true;
  }

  function syncCountryCodePicker(selectEl) {
    if (!selectEl || !selectEl.__countryCodePicker) return;

    var selectedOption = getSelectedCountryCodeOption(selectEl);
    if (!selectedOption) return;

    var picker = selectEl.__countryCodePicker;
    picker.button.setAttribute('aria-label', selectedOption.dataset.country || selectedOption.textContent || 'Select country');

    if (selectedOption.dataset.flagUrl) {
      picker.buttonFlag.src = selectedOption.dataset.flagUrl;
      picker.buttonFlag.alt = '';
      picker.buttonFlag.hidden = false;
    } else {
      picker.buttonFlag.hidden = true;
      picker.buttonFlag.removeAttribute('src');
    }

    Array.prototype.forEach.call(picker.list.querySelectorAll('[data-country-option-index]'), function (item) {
      var isSelected = Number(item.dataset.countryOptionIndex) === selectEl.selectedIndex;
      item.setAttribute('aria-selected', isSelected ? 'true' : 'false');
    });
  }

  function enhanceCountryCodePicker(selectEl) {
    if (!selectEl || selectEl.dataset.countryCodePicker !== 'flags') return;

    if (selectEl.__countryCodePicker) {
      selectEl.__countryCodePicker.list.innerHTML = '';
    }

    var picker = selectEl.__countryCodePicker;

    if (!picker) {
      var wrapper = document.createElement('div');
      wrapper.className = 'contact-form__country-code-picker contact-form__input--country-code';

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'contact-form__input contact-form__country-code-button';
      button.setAttribute('aria-haspopup', 'listbox');
      button.setAttribute('aria-expanded', 'false');

      var buttonLabel = document.createElement('span');
      buttonLabel.className = 'contact-form__country-code-button-label';

      var buttonFlag = document.createElement('img');
      buttonFlag.className = 'contact-form__country-code-flag';
      buttonFlag.alt = '';
      buttonFlag.loading = 'lazy';

      buttonLabel.appendChild(buttonFlag);

      var buttonCaret = document.createElement('span');
      buttonCaret.className = 'contact-form__country-code-button-caret';
      buttonCaret.setAttribute('aria-hidden', 'true');
      buttonCaret.textContent = '▼';

      button.appendChild(buttonLabel);
      button.appendChild(buttonCaret);

      var list = document.createElement('div');
      list.className = 'contact-form__country-code-list';
      list.setAttribute('role', 'listbox');
      list.hidden = true;

      wrapper.appendChild(button);
      wrapper.appendChild(list);
      selectEl.insertAdjacentElement('afterend', wrapper);

      button.addEventListener('click', function () {
        var shouldOpen = list.hidden;
        closeCountryCodePicker(selectEl);
        list.hidden = !shouldOpen;
        button.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
      });

      document.addEventListener('click', function (event) {
        if (!wrapper.contains(event.target)) {
          closeCountryCodePicker(selectEl);
        }
      });

      button.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowDown' || event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          if (list.hidden) {
            list.hidden = false;
            button.setAttribute('aria-expanded', 'true');
          }
          var selectedItem = list.querySelector('[aria-selected="true"]') || list.querySelector('[data-country-option-index]');
          if (selectedItem) {
            selectedItem.focus();
          }
        }
      });

      list.addEventListener('keydown', function (event) {
        var items = Array.prototype.slice.call(list.querySelectorAll('[data-country-option-index]'));
        var currentIndex = items.indexOf(document.activeElement);

        if (event.key === 'Escape') {
          event.preventDefault();
          closeCountryCodePicker(selectEl);
          button.focus();
          return;
        }

        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          if (!items.length) return;
          var nextIndex = currentIndex;
          if (event.key === 'ArrowDown') nextIndex = Math.min(currentIndex + 1, items.length - 1);
          if (event.key === 'ArrowUp') nextIndex = Math.max(currentIndex - 1, 0);
          if (currentIndex === -1) nextIndex = 0;
          items[nextIndex].focus();
        }
      });

      picker = {
        wrapper: wrapper,
        button: button,
        buttonFlag: buttonFlag,
        list: list
      };

      selectEl.__countryCodePicker = picker;
    }

    Array.prototype.forEach.call(selectEl.options, function (option, index) {
      var item = document.createElement('button');
      item.type = 'button';
      item.className = 'contact-form__country-code-option';
      item.setAttribute('role', 'option');
      item.setAttribute('aria-label', option.dataset.country || option.textContent || 'Select country');
      item.dataset.countryOptionIndex = index;

      var itemLabel = document.createElement('span');
      itemLabel.className = 'contact-form__country-code-option-label';

      var itemText = document.createElement('span');
      itemText.textContent = option.dataset.country || option.textContent || '';

      itemLabel.appendChild(itemText);
      item.appendChild(itemLabel);

      item.addEventListener('click', function () {
        selectEl.selectedIndex = index;
        selectEl.dispatchEvent(new Event('change', { bubbles: true }));
        closeCountryCodePicker(selectEl);
      });

      picker.list.appendChild(item);
    });

    syncCountryCodePicker(selectEl);
  }

  function populateAllCountryOptions(selectEl) {
    return fetchAllCountries().then(function (countries) {
      var fragment = document.createDocumentFragment();
      var selectedValue = normalizeCallingCode(selectEl.value || '+1');
      var selectedCountryName = 'United States';
      var hasSelected = false;

      countries.forEach(function (country) {
        var option = document.createElement('option');
        option.value = country.code;
        option.dataset.callingCode = country.code;
        option.dataset.country = country.name;
        option.dataset.flagUrl = country.flagUrl || '';
        option.dataset.isoCode = country.iso2 || '';
        option.textContent = country.name;

        if (isSameCountryName(country.name, 'United States') && country.code === '+1') {
          option.defaultSelected = true;
        }

        if (!hasSelected && country.code === selectedValue && isSameCountryName(country.name, selectedCountryName)) {
          option.selected = true;
          hasSelected = true;
        }

        fragment.appendChild(option);
      });

      selectEl.innerHTML = '';
      selectEl.appendChild(fragment);

      if (!hasSelected) {
        var defaultUs = Array.prototype.find.call(selectEl.options, function (opt) {
          return isSameCountryName(opt.dataset.country, 'United States');
        });

        if (defaultUs) {
          defaultUs.selected = true;
        }
      }
    });
  }

  function populateCountryNameOptions(selectEl) {
    return fetchAllCountries().then(function (countries) {
      var fragment = document.createDocumentFragment();
      var hasSelected = false;

      countries.forEach(function (country) {
        var option = document.createElement('option');
        option.value = country.name;
        option.dataset.callingCode = country.code;
        option.textContent = country.name;

        if (isSameCountryName(country.name, 'United States')) {
          option.defaultSelected = true;
          option.selected = true;
          hasSelected = true;
        }

        fragment.appendChild(option);
      });

      selectEl.innerHTML = '';
      selectEl.appendChild(fragment);

      if (!hasSelected && selectEl.options.length) {
        selectEl.options[0].selected = true;
      }
    });
  }

  function populateWholesaleRegionOptions(form) {
    var countryNameSelect = form.querySelector('[name="country"][data-country-name-select="true"]');
    var regionSelect = form.querySelector('[name="province"][data-region-select="true"]');
    if (!countryNameSelect || !regionSelect) return Promise.resolve();

    var selectedCountryName = (countryNameSelect.value || '').trim();

    return fetchCountryRegions(selectedCountryName).then(function (config) {
      var fragment = document.createDocumentFragment();

      if (config && config.values && config.values.length) {
        var placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.disabled = true;
        placeholder.selected = true;
        placeholder.textContent = config.label;
        fragment.appendChild(placeholder);

        config.values.forEach(function (region) {
          var option = document.createElement('option');
          option.value = region;
          option.textContent = region;
          fragment.appendChild(option);
        });
      } else {
        var genericPlaceholder = document.createElement('option');
        genericPlaceholder.value = '';
        genericPlaceholder.disabled = true;
        genericPlaceholder.selected = true;
        genericPlaceholder.textContent = 'Region';
        fragment.appendChild(genericPlaceholder);

        var fallbackOption = document.createElement('option');
        fallbackOption.value = 'N/A';
        fallbackOption.textContent = 'N/A';
        fragment.appendChild(fallbackOption);
      }

      regionSelect.innerHTML = '';
      regionSelect.appendChild(fragment);
    });
  }

  function syncCountryAndPrefix(form) {
    var variant = form.dataset.formVariant;
    var countryCodeSelect = form.querySelector('[name="countryCode"]');
    var countryNameSelect = form.querySelector('[name="country"][data-country-name-select="true"]');
    var hiddenCountry = form.querySelector('input[name="country"]');

    if (variant === 'wholesale') {
      // Wholesale shipping country and phone country are independent.
      // Only phone country selector controls phone prefix and countryCode.
      updatePhonePrefix(form);
      return;
    }

    if (hiddenCountry) {
      hiddenCountry.value = getSelectedCountryFromCode(form);
    }

    updatePhonePrefix(form);
  }

  function parseResponseSafe(response) {
    return response
      .text()
      .then(function (text) {
        if (!text) return {};
        try {
          return JSON.parse(text);
        } catch (error) {
          return {};
        }
      });
  }

  function setStatus(form, type, message) {
    var errorBox = form.querySelector('.contact-form__error');
    var successBox = form.querySelector('.contact-form__success');

    if (errorBox) {
      errorBox.hidden = true;
      errorBox.textContent = '';
    }

    if (successBox) {
      successBox.hidden = true;
      successBox.textContent = '';
    }

    if (type === 'error' && errorBox) {
      errorBox.textContent = message;
      errorBox.hidden = false;
    }

    if (type === 'success' && successBox) {
      successBox.textContent = message;
      successBox.hidden = false;
    }
  }

  function setLoadingState(form, loading) {
    var submitButton = form.querySelector('[type="submit"]');
    if (!submitButton) return;

    if (loading) {
      submitButton.disabled = true;
      submitButton.dataset.originalLabel = submitButton.textContent;
      submitButton.textContent = 'Submitting...';
      return;
    }

    submitButton.disabled = false;
    if (submitButton.dataset.originalLabel) {
      submitButton.textContent = submitButton.dataset.originalLabel;
    }
  }

  function getSelectedCountryFromCode(form) {
    var countryCodeSelect = form.querySelector('[name="countryCode"]');
    if (!countryCodeSelect) return '';

    var selectedOption = countryCodeSelect.options[countryCodeSelect.selectedIndex];
    if (!selectedOption) return '';

    if (selectedOption.dataset.country) {
      return selectedOption.dataset.country;
    }

    var text = (selectedOption.textContent || '').trim();
    var bracketIndex = text.indexOf('+');
    if (bracketIndex > 0) {
      return text.slice(0, bracketIndex).trim();
    }

    return 'United States';
  }

  function buildPayload(form) {
    var variant = form.dataset.formVariant;
    var formData = new FormData(form);
    var payload = {};
    var companyDescription = (formData.get('companyDescription') || '').toString().trim();

    if (variant === 'wholesale') {
      payload = {
        country: (formData.get('country') || '').toString().trim(),
        firstName: (formData.get('firstName') || '').toString().trim(),
        lastName: (formData.get('lastName') || '').toString().trim(),
        companyAttention: (formData.get('companyAttention') || '').toString().trim(),
        address: (formData.get('address') || '').toString().trim(),
        address2: (formData.get('address2') || '').toString().trim(),
        city: (formData.get('city') || '').toString().trim(),
        province: (formData.get('province') || '').toString().trim(),
        postalCode: (formData.get('postalCode') || '').toString().trim(),
        countryCode: (formData.get('countryCode') || '').toString().trim(),
        phoneNumber: (formData.get('phoneNumber') || '').toString().trim(),
        email: (formData.get('email') || '').toString().trim(),
        website: (formData.get('website') || '').toString().trim(),
        socialMediaHandle: (formData.get('socialMediaHandle') || '').toString().trim(),
        estimatedOrderVolume: (formData.get('estimatedOrderVolume') || '').toString().trim()
      };

      if (companyDescription) {
        payload.companyDescription = companyDescription;
      }

      return payload;
    }

    payload = {
      firstName: (formData.get('firstName') || '').toString().trim(),
      lastName: (formData.get('lastName') || '').toString().trim(),
      country: (formData.get('country') || '').toString().trim(),
      countryCode: (formData.get('countryCode') || '').toString().trim(),
      phoneNumber: (formData.get('phoneNumber') || '').toString().trim(),
      email: (formData.get('email') || '').toString().trim(),
      message: (formData.get('message') || '').toString().trim()
    };

    return payload;
  }

  function hasHoneypotValue(form) {
    var honeypot = form.querySelector('input[name="website_url"]');
    if (!honeypot) return false;

    return Boolean((honeypot.value || '').trim());
  }

  function handleSubmit(event) {
    event.preventDefault();

    var form = event.currentTarget;

    if (hasHoneypotValue(form)) {
      return;
    }

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    syncCountryAndPrefix(form);

    var endpoint = form.dataset.apiEndpoint;
    if (!endpoint) {
      setStatus(form, 'error', 'Missing API endpoint. Please update this block setting in theme editor.');
      return;
    }

    var payload = buildPayload(form);

    setLoadingState(form, true);
    setStatus(form, null, '');

    fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        return parseResponseSafe(response).then(function (data) {
          if (!response.ok || data.ok === false) {
            var message = data.message || 'Submission failed. Please try again.';
            throw new Error(message);
          }
          return data;
        });
      })
      .then(function () {
        setStatus(form, 'success', 'Thank you. Your form has been submitted.');
        form.reset();
        syncCountryAndPrefix(form);
      })
      .catch(function (error) {
        setStatus(form, 'error', error.message || 'Something went wrong. Please try again.');
      })
      .finally(function () {
        setLoadingState(form, false);
      });
  }

  function initForm(form) {
    if (form.dataset.contactApiBound === 'true') return;
    form.dataset.contactApiBound = 'true';

    var countryCodeSelect = form.querySelector('[name="countryCode"]');
    var countryNameSelect = form.querySelector('[name="country"][data-country-name-select="true"]');
    var tasks = [];

    if (countryCodeSelect && countryCodeSelect.dataset.allCountries === 'true') {
      tasks.push(populateAllCountryOptions(countryCodeSelect));
    }

    if (countryNameSelect && countryNameSelect.dataset.allCountries === 'true') {
      tasks.push(populateCountryNameOptions(countryNameSelect));
    }

    Promise.all(tasks).then(function () {
      enhanceCountryCodePicker(countryCodeSelect);
      if (form.dataset.formVariant === 'wholesale') {
        populateWholesaleRegionOptions(form);
      }
      syncCountryAndPrefix(form);
    });

    if (countryCodeSelect) {
      countryCodeSelect.addEventListener('change', function () {
        syncCountryAndPrefix(form);
      });
    }

    if (countryNameSelect) {
      countryNameSelect.addEventListener('change', function () {
        if (form.dataset.formVariant === 'wholesale') {
          populateWholesaleRegionOptions(form);
        }
        syncCountryAndPrefix(form);
      });
    }

    syncCountryAndPrefix(form);
    form.addEventListener('submit', handleSubmit);
  }

  function init() {
    var forms = document.querySelectorAll('.js-contact-api-form');
    forms.forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
    return;
  }

  init();
})();
